import { Component, OnInit, Input } from '@angular/core';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../../shared-components/confirmation-dialog/confirmation-dialog.component';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-catalogs-catalog-resume-card',
  templateUrl: './catalogs-catalog-resume-card.component.html',
  styleUrls: ['./catalogs-catalog-resume-card.component.scss']
})
export class CatalogsCatalogResumeCardComponent implements OnInit {

  @Input() catalog: CatalogBasic;
  @Input() viewDisposition;
  deleteCatalogSubscription: Subscription;
  updateCatalogStatusSubscription: Subscription;

  constructor(private catalogsService: CatalogsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private dialog: MatDialog) { }

  ngOnInit() {
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['/catalog/catalog', this.catalog.InternalId]);
    }
  }

  public toggleStatus() {
    this.updateCatalogStatusSubscription = this.catalogsService.updateCatalogStatus(this.catalog.InternalId, !this.catalog.Active).subscribe(
      (res) => {
        this.catalogsService.refreshCatalogs();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteCatalog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['catalogs-page.delete catalog', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteCatalogSubscription = this.catalogsService.deleteCatalog([this.catalog.InternalId]).subscribe(
          (res) => {
            this.catalogsService.refreshCatalogs();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }
}
